import { render, staticRenderFns } from "./TextHighlighted.vue?vue&type=template&id=4e82cc2d&scoped=true&"
import script from "./TextHighlighted.vue?vue&type=script&lang=js&"
export * from "./TextHighlighted.vue?vue&type=script&lang=js&"
import style0 from "./TextHighlighted.vue?vue&type=style&index=0&id=4e82cc2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e82cc2d",
  null
  
)

export default component.exports